import extraRewardsDeals from './extraRewardsDeals';

export default extraRewardsDeals;
